import { parse } from 'querystring';

const reg =
  /(((^https?:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)$/;

export const isUrl = (path: string): boolean => reg.test(path);

export const getPageQuery = () => parse(window.location.href.split('?')[1]);

export const copyArrayObject = (a: any) => {
  var c = [];
  c = JSON.parse(JSON.stringify(a));
  return c;
};

export const waitTime = (time: number = 100) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

export const isLogin = () => {
  return getToken() ? true : false;
};

export const setToken = (token: any) => {
  // return sessionStorage.setItem('token', token);
  return localStorage.setItem('token', token);
};
export const clearToken = () => {
  return localStorage.removeItem('token');
};

export const getToken = () => {
  // return sessionStorage.getItem('token');
  return localStorage.getItem('token');
};
